export function unlockDuration(lastFailedAttemptTimeStamp, lockDurationInMin) {
    if (!lastFailedAttemptTimeStamp || !lockDurationInMin) return null;

    const now = new Date();
    const lastAttempt = new Date(lastFailedAttemptTimeStamp);
    const millisecondsInOneMin = 60000;
    const elapsed = Math.floor((now - lastAttempt) / millisecondsInOneMin);
    const minLeft = lockDurationInMin - elapsed;

    return minLeft;
}



// WEBPACK FOOTER //
// ./src/modules/time.js